import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './Taskassignmentretrival.css';
import ProjectManagerAside from './ProjectManagerAside';

function TaskAssignmentForm() {
  const [formData, setFormData] = useState({
    projecttitle: '',
    assignto: '', // EmpId entered here
    empName: '', // Fetch empName based on assignto
    addtask: '',
    startdate: '', // Changed to startdate
    starttime: '', // Added starttime
    enddate: '',   // Changed to enddate
    endtime: '',   // Added endtime
    note: '',
  });

  const [projects, setProjects] = useState([]);
  const [successMessage, setSuccessMessage] = useState('');
  const [errorMessage, setErrorMessage] = useState('');

  useEffect(() => {
    axios.get('https://cleezoclass.com:8443/api/project-titles')
      .then((response) => {
        setProjects(response.data);
      })
      .catch((error) => {
        console.error('Error fetching project titles:', error);
        alert('Error fetching project titles. Please try again later.');
      });
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;

    // Convert assignto (EmpId) value to uppercase
    if (name === 'assignto') {
      setFormData({ ...formData, [name]: value.toUpperCase() });  // Ensure empId is uppercase
    } else {
      setFormData({ ...formData, [name]: value });
    }

    // If empId is entered, fetch empName automatically
    if (name === 'assignto') {
      const enteredEmpId = value.toUpperCase(); // Ensure empId is uppercase
      if (enteredEmpId) {
        axios.get(`https://cleezoclass.com:8443/api/employee/${enteredEmpId}`)
          .then((response) => {
            setFormData((prevFormData) => ({
              ...prevFormData,
              empName: response.data.empName,
            }));
            setErrorMessage('');
          })
          .catch((error) => {
            console.error('Error fetching employee:', error);
            setFormData((prevFormData) => ({
              ...prevFormData,
              empName: 'No employee found with this ID', // Set the error message directly in the empName field
            }));
            setErrorMessage(''); // No need for separate errorMessage state, it's inside the input now
          });
      } else {
        setFormData((prevFormData) => ({
          ...prevFormData,
          empName: '', // Clear empName when empId is empty
        }));
        setErrorMessage('');
      }
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    // Log start and end dates and times for debugging
    console.log("Start Date:", formData.startdate);
    console.log("Start Time:", formData.starttime);
    console.log("End Date:", formData.enddate);
    console.log("End Time:", formData.endtime);

    // Check if required fields are empty
    if (!formData.projecttitle || !formData.assignto || !formData.addtask || !formData.startdate || !formData.starttime || !formData.enddate || !formData.endtime) {
      alert('All fields are required except Note');
      return;
    }

    // Prepare the data to be sent
    const dataToSend = {
      projecttitle: formData.projecttitle,
      assignto: formData.assignto,
      empName: formData.empName,
      addtask: formData.addtask,
      startdate: formData.startdate,
      starttime: formData.starttime,
      enddate: formData.enddate,
      endtime: formData.endtime,
      note: formData.note || '', // Ensure the note is sent even if empty
    };

    // Log the data being sent for debugging
    console.log('Sending data:', dataToSend);

    // Send the data to the backend API
    axios.post('https://cleezoclass.com:8443/api/save-task', dataToSend)
      .then((response) => {
        setSuccessMessage('Task updated successfully!');
        setFormData({
          projecttitle: '',
          assignto: '',
          empName: '',
          addtask: '',
          startdate: '',
          starttime: '',
          enddate: '',
          endtime: '',
          note: '',
        });
      })
      .catch((error) => {
        setErrorMessage('Error saving task, please try again.');
        console.error('Error submitting form:', error.response?.data || error);
      });
  };

  return (
    <div className=" mainBlock">
      <ProjectManagerAside />
    <form onSubmit={handleSubmit} className="taskassignment-retrival-form">
    <h3 style={{ marginBottom: '30px', textAlign: 'center', fontSize: '1.5rem', color: '#333' }}>
  Task Assignment 
</h3>
  
      {/* First Row: Project Title, Assign To, Employee Name */}
      <div className="taskassignment-retrival-row">
        <div className="taskassignment-retrival-group">
          <label htmlFor="projecttitle" className="taskassignment-retrival-label">Project Title:</label>
          <select
            id="projecttitle"
            name="projecttitle"
            value={formData.projecttitle}
            onChange={handleChange}
            required
            className="taskassignment-retrival-input"
          >
            <option value="">Select Project:</option>
            {projects.map((project) => (
              <option key={project.projectTitle} value={project.projectTitle}>
                {project.projectTitle}
              </option>
            ))}
          </select>
        </div>
  
        <div className="taskassignment-retrival-group">
          <label htmlFor="assignto" className="taskassignment-retrival-label">Assign To (Employee ID):</label>
          <input
            type="text"
            id="assignto"
            name="assignto"
            value={formData.assignto}
            onChange={handleChange}
            placeholder="Enter Employee ID"
            required
            className="taskassignment-retrival-input"
          />
        </div>
  
        <div className="taskassignment-retrival-group">
          <label htmlFor="empName" className="taskassignment-retrival-label">Employee Name:</label>
          <input
            type="text"
            id="empName"
            name="empName"
            value={formData.empName}
            readOnly
            className="taskassignment-retrival-input"
            style={{
              borderColor: formData.empName === 'No employee found with this ID' ? 'red' : '',
              color: formData.empName === 'No employee found with this ID' ? 'red' : '',
            }}
          />
        </div>
      </div>
  
      {/* Second Row: Assign Task, Start Date, End Date */}
      <div className="taskassignment-retrival-row">
        <div className="taskassignment-retrival-group">
          <label htmlFor="addtask" className="taskassignment-retrival-label">Assign Task:</label>
          <input
            type="text"
            id="addtask"
            name="addtask"
            value={formData.addtask}
            onChange={handleChange}
            required
            className="taskassignment-retrival-input"
          />
        </div>
  
        <div className="taskassignment-retrival-group">
          <label htmlFor="startdate" className="taskassignment-retrival-label">Start Date:</label>
          <input
            type="date"
            id="startdate"
            name="startdate"
            value={formData.startdate}
            onChange={handleChange}
            required
            className="taskassignment-retrival-input"
          />
        </div>
  
        <div className="taskassignment-retrival-group">
          <label htmlFor="enddate" className="taskassignment-retrival-label">End Date:</label>
          <input
            type="date"
            id="enddate"
            name="enddate"
            value={formData.enddate}
            onChange={handleChange}
            required
            className="taskassignment-retrival-input"
          />
        </div>
      </div>
  
      {/* Third Row: Start Time, End Time, Note */}
      <div className="taskassignment-retrival-row">
        <div className="taskassignment-retrival-group">
          <label htmlFor="starttime" className="taskassignment-retrival-label">Start Time:</label>
          <input
            type="time"
            id="starttime"
            name="starttime"
            value={formData.starttime}
            onChange={handleChange}
            required
            className="taskassignment-retrival-input"
          />
        </div>
  
        <div className="taskassignment-retrival-group">
          <label htmlFor="endtime" className="taskassignment-retrival-label">End Time:</label>
          <input
            type="time"
            id="endtime"
            name="endtime"
            value={formData.endtime}
            onChange={handleChange}
            required
            className="taskassignment-retrival-input"
          />
        </div>
  
        <div className="taskassignment-retrival-group">
          <label htmlFor="note" className="taskassignment-retrival-label">Note:</label>
          <textarea
            id="note"
            name="note"
            value={formData.note}
            onChange={handleChange}
            rows="4"
            className="taskassignment-retrival-textarea"
          ></textarea>
        </div>
      </div>
  
      <button type="submit" className="taskassignment-retrival-btn">Submit</button>
  
      {successMessage && <div className="success-message">{successMessage}</div>}
      {errorMessage && <div className="error-message">{errorMessage}</div>}
    </form>
  </div>
  
  );
}

export default TaskAssignmentForm;
